import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const GetWeeks = createAsyncThunk('get-week', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-attendance/get-week`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const GetSubjectDetails = createAsyncThunk('student-details', async ({ classSemesterId, semesterSubjectId }: { classSemesterId: string; semesterSubjectId: string }, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-attendance/get-subject-details/${classSemesterId}/${semesterSubjectId}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const ListStudentSemesterAttendance = createAsyncThunk('student-attendance-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-attendance/list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const createStudentAttendance = createAsyncThunk('student-attendance-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-attendance/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const PrintEmptyAttendance = createAsyncThunk('print-empty-attendance', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-attendance/print-empty-attendance`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const PrintAttendance = createAsyncThunk('print-attendance', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-attendance/print-attendance`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const getTermList = createAsyncThunk('get-term-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-attendance/get-term-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getClass = createAsyncThunk('get-class-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-attendance/get-class-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getSemesters = createAsyncThunk('get-semesters-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-attendance/get-semesters-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getSemesterSubjects = createAsyncThunk('get-semester-subjects-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-attendance/get-semester-subjects-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const studentAttendanceReport = createAsyncThunk('student-attendance-report', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student-attendance/report-attendance`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

type studentAttendanceState = {
  errors: any
}

const initialState: studentAttendanceState = {
  errors: '',
}

export const studentAttendanceSlice = createSlice({
  name: 'student-attendance',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
  },
})

export const { reset } = studentAttendanceSlice.actions
export default studentAttendanceSlice.reducer
